/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnPrivacy.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnPrivacy-view">
        <Helmet>
          <title>Privacy - CheckPlus</title>
        </Helmet>
        {renderHomePageHeader(this)}
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        <div className="EnPrivacy-section">
          <div className="EnPrivacy-privacy">
            <div className="EnPrivacy-privacyIcn" />
            <div className="EnPrivacy-privacyTxt">Privacy</div>
            <div className="EnPrivacy-privacyDescription">
              Your data should be yours.
            </div>
            <div className="EnPrivacy-privacyDescription2">
              Privacy is very important to us. We at CheckPlus believe your data
              should stay yours, this is why CheckPlus has pledged to never sell
              or share our user data to any third-party company without specific
              consent. We have always designed CheckPlus with privacy in mind,
              so that you can be rest assure.
            </div>

            <Link to="/EnPrivacyPolicy">
              <div className="EnPrivacy-privacyBtn">
                <div className="EnPrivacy-privacyBtnTxt">
                  View our privacy policy
                </div>
                <div className="EnPrivacy-privacyNext" />
              </div>
            </Link>
          </div>

          <div className="EnPrivacy-aws">
            <div className="EnPrivacy-leftContainer">
              <div className="EnPrivacy-leftGroup">
                <div className="EnPrivacy-storageIcn" />
                <div className="EnPrivacy-heading">Secure Data Storage</div>
                <div className="EnPrivacy-description">
                  Your data is securely stored in our AWS cloud.
                </div>
                <div className="EnPrivacy-tickContainer">
                  <div className="EnPrivacy-tickIcn" />
                  <div className="EnPrivacy-tickTxt">HTTPS</div>
                </div>
                <div className="EnPrivacy-tickContainer">
                  <div className="EnPrivacy-tickIcn" />
                  <div className="EnPrivacy-tickTxt">SSL</div>
                </div>
                <div className="EnPrivacy-tickContainer">
                  <div className="EnPrivacy-tickIcn" />
                  <div className="EnPrivacy-tickTxt">ISO27001 Certified</div>
                </div>
              </div>
              <div className="EnPrivacy-blackFilter"></div>
            </div>
            <div className="EnPrivacy-rightContainer">
              <div className="EnPrivacy-awsLogo" />
            </div>
          </div>
          <div className="EnPrivacy-stripe">
            <div className="EnPrivacy-leftContainer">
              <div className="EnPrivacy-leftGroup">
                <div className="EnPrivacy-paymentIcn" />
                <div className="EnPrivacy-heading">Payment secured.</div>
                <div className="EnPrivacy-description">
                  All card numbers are encrypted with AES-256, the same
                  technology is also used by major banks and governments across
                  the world.
                </div>
              </div>
              <div className="EnPrivacy-blackFilter"></div>
            </div>
            <div className="EnPrivacy-rightContainer">
              <div className="EnPrivacy-stripeLogo" />
            </div>
          </div>
          <div className="EnPrivacy-checkplus">
            <div className="EnPrivacy-leftContainer">
              <div className="EnPrivacy-leftGroup">
                <div className="EnPrivacy-commitmentIcn" />
                <div className="EnPrivacy-heading">
                  The CheckPlus Commitment
                </div>
                <div className="EnPrivacy-description">
                  Our commitment to your privacy will continue and we will
                  actively look for more ways to protect your privacy.
                </div>
              </div>
              <div className="EnPrivacy-blackFilter"></div>
            </div>
            <div className="EnPrivacy-rightContainer">
              <div className="EnPrivacy-checkplusLogo" />
            </div>
          </div>
        </div>

        <div className="EnPrivacy-footer">
          <div className="EnPrivacy-footerNav">
            <Link to="/EnTeam">
              <div className="EnPrivacy-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnPrivacy-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnPrivacy-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnPrivacy-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnPrivacy-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnPrivacy;
